import { Injectable } from '@angular/core';
import { HttpWrapperService } from '@app/core/services/http-wrapper/http-wrapper.service';
import { Observable } from 'rxjs';
import {
    IMigrateLotsWizardHistoryLogicService
} from '@app/logic/migrate-lots-wizard-history/interfaces/i.migrate-lots-wizard-history.logic.service';
import { IMigrateLotsWizardHistoryRequestDto } from '@classictechsolutions/hubapi-transpiled-enums';

@Injectable()
export class MigrateLotsWizardHistoryLogicService implements IMigrateLotsWizardHistoryLogicService {
    public static readonly BASE_URI = 'lots/migratelotswizardhistory';

    constructor(protected readonly $http: HttpWrapperService) {}

    public addHistoryEntries(
        request: IMigrateLotsWizardHistoryRequestDto
    ): Observable<boolean> {
        return this.$http.post<boolean>(
            MigrateLotsWizardHistoryLogicService.BASE_URI,
            request
        );
    }
}
